import React from "react";
import {
  GrantAgreementDiv,
  GrantAgreementHead,
  GrantDescription
} from "../styles";
import PropTypes from "prop-types";

class GrantAgreement extends React.Component {
  componentDidMount() {
    setTimeout(this.props.ctaEventHandler);
  }
  render() {
    return (
      <GrantAgreementDiv data-test="grantAgreementDiv">
        <GrantAgreementHead>
          {this.props.grantAgreementTitle}
        </GrantAgreementHead>
        <GrantDescription dangerouslySetInnerHTML={{ __html: this.props.grantAgreementDescription }} />
      </GrantAgreementDiv>
    )
  }
}

GrantAgreement.propTypes = {
  ctaEventHandler: PropTypes.func,
  grantAgreementDescription: PropTypes.string,
  grantAgreementTitle: PropTypes.string,
  pageTitle: PropTypes.string
}

export default GrantAgreement;
